import { IconHeart, IconHeartFilled } from "@tabler/icons-react";
import Authorized from "../../core/auth/Authorized.tsx";
import { openModal } from "../../core/PopUp.tsx";
import { MODAL_LOGIN_ID } from "../../login/LoginModal.tsx";
import FavoriteItem from "./FaveoriteItem.tsx";
import ItemBreadcrumbs from "./ItemBreadcrumbs";
import ItemImage from "./ItemImage.tsx";
import ItemPrice from "./ItemPrice.tsx";
import ItemPrimaryInfos from "./ItemPrimaryInfos.tsx";
import ItemTitle from "./ItemTitle.tsx";

const ItemListElem = ({ id }: { id: string }) => {
  return (
    <div className="card card-side bg-base-200">
      <figure className="lg:w-52 min-w-42 aspect-square p-1">
        <div className="relative h-full w-full">
          <ItemImage
            className="h-full w-full rounded-xl"
            id={id}
            sizes={"128px"}
          />
          <div className="absolute top-2 right-2">
            <Authorized
              ifUnauthorized={
                <button
                  type="button"
                  className="btn btn-circle"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openModal(MODAL_LOGIN_ID);
                  }}
                >
                  <IconHeart />
                </button>
              }
            >
              <FavoriteItem
                itemId={id}
                className="btn-circle"
                favoriteActiveChildren={<IconHeartFilled />}
                favoriteInactiveChildren={<IconHeart />}
              />
            </Authorized>
          </div>
        </div>
      </figure>
      <div className="card-body">
        <div className="flex gap-2">
          <ItemPrimaryInfos itemId={id} />
        </div>
        <h2 className="text-lg justify-between ">
          <ItemTitle id={id} />
        </h2>
        <div className="flex flex-wrap">
          <ItemBreadcrumbs itemId={id} />
        </div>
        <ItemPrice id={id} />
      </div>
    </div>
  );
};
export default ItemListElem;
